import { useEffect } from 'react';

/**
 * Measures component mount time relative to navigation start mark.
 * Only active in development mode; no-ops in production.
 */
export function useDevPerformanceMeasure(): void {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    try {
      const marks = performance.getEntriesByName('nav-start');
      if (marks.length > 0) {
        console.timeEnd('🚀 Navigation: Click to URL change');  
        performance.mark('page-mount');
        performance.measure('Navigation time', 'nav-start', 'page-mount');

        const navMeasure = performance.getEntriesByName('Navigation time')[0];
        if (navMeasure) {
          console.log(`🚀 Navigation: ${navMeasure.duration.toFixed(2)}ms`);  
        }
      }
    } catch {
      // Silent catch
    }
  }, []);
}
